import { VStack, Heading, Icon, Text, HStack, Collapse, StackDivider } from '@chakra-ui/react';

import { IoStopwatchOutline, IoChevronDownOutline } from 'react-icons/io5';

export type RecordContainerProps = {
  id: string;
  time: string;
  isOpen: boolean;
  containerList: Array<{ id: string; name: string; count: number }>;
  onChangeOpenOrder: (id: string) => void;
};

// 歸還餐盒紀錄Container
export default function RecordContainer({
  id,
  time,
  isOpen,
  containerList,
  onChangeOpenOrder,
}: RecordContainerProps) {
  return (
    <VStack spacing={0} cursor="pointer">
      <HStack
        align="stretch"
        justify="space-between"
        bgColor="secondary"
        borderTopRadius="5px"
        width="full"
        py={2}
        px={3}
        onClick={() => onChangeOpenOrder(id)}
        position={'sticky'}
        zIndex={'auto'}
        top={20}
      >
        <Heading fontSize="sm" letterSpacing={2} color="white">
          {id}
        </Heading>

        <Icon
          color="primaryLight"
          as={IoChevronDownOutline}
          transition="0.3s"
          transform={`rotateX(${isOpen ? -180 : 0}deg)`}
        />
      </HStack>
      <VStack
        p={2}
        align="stretch"
        width="full"
        borderBottomRadius="5px"
        borderTop="none"
        borderColor="gray.400"
        borderWidth="1px"
        spacing={1}
      >
        <HStack spacing={1} align="center" py={1}>
          <Icon as={IoStopwatchOutline} boxSize="1.125rem" />
          <Text fontSize="xs">歸還期限：{time}</Text>
        </HStack>

        {isOpen && <StackDivider borderTopWidth="1px" borderColor="gray.400" />}

        <Collapse in={isOpen}>
          <VStack align="stretch" divider={<StackDivider borderColor="gray.400" />}>
            {containerList.map((container) => (
              <HStack key={container.id} justify="space-between" py={1} pr={2} fontSize="sm">
                <Text>{container.name}</Text>
                <Text>{container.count}</Text>
              </HStack>
            ))}
          </VStack>
        </Collapse>
      </VStack>
    </VStack>
  );
}
